
export const productActionsMap = {
  apply: [
    1326, 1324, 1325, 1322, 1321, 1323, 1351, 1335, 1336, 1337, 1338, 1339, 1331, 1329, 1330, 1327, 1328, 1364, 1365, 1371, 1370, 1332, 1367, 1368, 1468, 1372, 1431, 1433, 1458, 1434, 1613, 1615
  ],
  appointment: [
    1334, 1362, 1352, 1340, 1690, 1366
  ],
  contactWealth: [
    1359
  ],
  contactFinancial: [
    1689, 1691,
  ]
};
